import React, { Component } from 'react';
import Page from '../../components/Page';
import { Icon, Segment, Form, Table, Button, Modal, Header, Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';
import { getContactLists, uploadContactList, deleteContactList, getContactListPage } from '../../util/contacts';

const TABS = [
	{ key: 'telegramList', label: 'Telegram Bot API' },
	{ key: 'contactList', label: 'Telegram Web API' },
];

class Phones extends Component {
	state = {
		activeTab: 'telegramList',
		loading: true,
		telegramList: [],
		contactList: [],
		loadingBtn: false,
		message: false,
		openModal: false,
		deleteModal: false,
		numberList: [],
		selectedExcel: null,
		deleteButtonLoading: false,
	};

	componentDidMount() {
		Promise.all([this.getList('telegramList'), this.getList('contactList')]).then(() => {
			this.setState({ loading: false });
		});
	}

	getList(key) {
		return getContactLists(key)
			.then((lists) => this.setState({ [key]: lists }))
			.catch(() => this.setState({ [key]: [] }));
	}

	deleteList() {
		let { selectedExcel, activeTab } = this.state;
		this.setState({ deleteButtonLoading: true });
		deleteContactList(selectedExcel.id).then(() => {
			this.setState({ deleteButtonLoading: false, deleteModal: false });
			this.getList(activeTab);
		});
	}

	// Önizleme: ilk 1000 kişi
	openPreview(it) {
		this.setState({ openModal: true, numberList: [], selectedExcel: it, previewLoading: true });
		getContactListPage(it.id, { limit: 1000 })
			.then((page) => this.setState({ numberList: page.data, previewLoading: false }))
			.catch(() => this.setState({ previewLoading: false }));
	}

	fileUpload(file) {
		let { activeTab } = this.state;
		this.setState({ loadingBtn: true, message: false, uploadError: null });
		uploadContactList(file, activeTab)
			.then((data) => {
				this.setState({ loadingBtn: false, message: !!data.success, uploadError: data.success ? null : data.error });
				this.getList(activeTab);
			})
			.catch((err) => this.setState({ loadingBtn: false, uploadError: err.message }));
	}

	handleFileInput = (e) => {
		let file = e.target.files[0];
		e.target.value = '';
		if (file) this.fileUpload(file);
	};

	downloadExample = () => {
		var a = document.createElement('a');
		a.href = '/contacts_example.xlsx';
		a.target = '_blank';
		a.download = 'contacts_example.xlsx';
		a.click();
	};

	renderList(list) {
		const { t } = this.props;
		return (
			<Table>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>{'Name'}</Table.HeaderCell>
						<Table.HeaderCell>{'Date'}</Table.HeaderCell>
						<Table.HeaderCell>{'Count'}</Table.HeaderCell>
						<Table.HeaderCell></Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{_.map(list, (it) => (
						<Table.Row key={it.id}>
							<Table.Cell>{it.name || moment(it.created_at).format('DD-MM-YYYY HH:mm:ss')}</Table.Cell>
							<Table.Cell>{moment(it.updated_at || it.created_at).format('DD-MM-YYYY')}</Table.Cell>
							<Table.Cell>{it.row_count}</Table.Cell>
							<Table.Cell>
								<Button
									icon
									size="mini"
									style={{ marginLeft: '10px' }}
									onClick={() => this.openPreview(it)}
								>
									<Icon name="eye" />
								</Button>
								<Button
									icon
									size="mini"
									style={{ marginLeft: '10px' }}
									onClick={() => this.setState({ deleteModal: true, selectedExcel: it })}
								>
									<Icon name="trash" />
								</Button>
							</Table.Cell>
						</Table.Row>
					))}
				</Table.Body>
			</Table>
		);
	}

	render() {
		const { t } = this.props;
		let { loadingBtn, message, uploadError, activeTab, loading, previewLoading } = this.state;

		if (loading) return <Page.Loader />;

		let activeTabObj = _.find(TABS, { key: activeTab });
		let list = this.state[activeTab] || [];

		return (
			<Segment>
				<Menu pointing secondary>
					{_.map(TABS, (tab) => (
						<Menu.Item
							key={tab.key}
							active={activeTab === tab.key}
							onClick={() => this.setState({ activeTab: tab.key, message: false })}
						>
							<Icon name="telegram" />
							{tab.label}
						</Menu.Item>
					))}
				</Menu>

				<div style={{ padding: '10px', width: '100%' }}>
					<Form>
						<Form.Field style={{ display: 'flex', marginBottom: '10px' }}>
							<div className="image-upload" style={{ margin: 'auto' }}>
								<label
									htmlFor={`file-input-${activeTab}`}
									className={`ui blue icon left labeled button ${loadingBtn ? 'loading' : ''}`}
								>
									{t('upload')}
									<Icon name="upload" style={{ cursor: 'pointer' }} />
								</label>
								<Button
									onClick={this.downloadExample}
									content={t('example download')}
									icon="download"
									labelPosition="left"
									color="teal"
								/>
							</div>
							<input
								id={`file-input-${activeTab}`}
								type="file"
								accept=".xlsx, .xls, .csv"
								style={{ display: 'none' }}
								onChange={this.handleFileInput}
							/>
						</Form.Field>
						{message && <p style={{ textAlign: 'center' }}>{t('messageExcelSuccess')}</p>}
						{uploadError && <p style={{ textAlign: 'center', color: 'red' }}>{uploadError}</p>}
					</Form>
				</div>

				{this.renderList(list)}

				<Modal open={this.state.openModal} onClose={() => this.setState({ openModal: false })} closeIcon>
					<Modal.Header>{this.state.selectedExcel && `${this.state.selectedExcel.name || ''} (${this.state.selectedExcel.row_count})`}</Modal.Header>
					<Modal.Content scrolling>
						{previewLoading ? <Page.Loader /> : null}
						<Table>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>{'Id'}</Table.HeaderCell>
									<Table.HeaderCell>{'Name'}</Table.HeaderCell>
									<Table.HeaderCell>{'Phone'}</Table.HeaderCell>
									<Table.HeaderCell>{'Website'}</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{_.map(this.state.numberList, (it, i) => (
									<Table.Row key={i}>
										<Table.Cell>{it['Users Id']}</Table.Cell>
										<Table.Cell>{it.Name || it.isim}</Table.Cell>
										<Table.Cell>{it.Phone}</Table.Cell>
										<Table.Cell>{it.Website}</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>
					</Modal.Content>
				</Modal>

				<Modal open={this.state.deleteModal} onClose={() => this.setState({ deleteModal: false })}>
					<Header icon="dont" content={t('delete')} />
					<Modal.Content>
						<p>{t('areYouSureDeleteExcel')}</p>
					</Modal.Content>
					<Modal.Actions>
						<Button color="red" onClick={() => this.setState({ deleteModal: false })}>
							<Icon name="remove" /> {t('no')}
						</Button>
						<Button color="green" onClick={() => this.deleteList()} loading={this.state.deleteButtonLoading}>
							<Icon name="checkmark" /> {t('yes')}
						</Button>
					</Modal.Actions>
				</Modal>
			</Segment>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Phones));
